import * as React from 'react';
import { observer } from 'mobx-react';
import { WebGivingPersonModel, WebGivingMerchant, BrandingPackage, Language } from '../../webgiving-generated';
import { Account } from '../../components/account/account';
import { ErrorBoundary } from '../../../Shared/components/error-boundary';
import { ErrorInfo } from '../../utils/error-utils';
import { MainHeader } from '../../components/header/header';
import { LanguageSelector } from '../../components/language-selector';
import { Skeleton } from '../../components/skeleton/skeleton';
import { ShouldTranslate } from '../../translation';
import { Text } from '../../components/text';

import * as styles from "./webgiving-main-header.less";
import { NotificationViewModel } from '../../components/notification/notification';

export interface IHeaderProps {
	merchant: WebGivingMerchant;
	brandingPackage: BrandingPackage | null;
	person: WebGivingPersonModel | null;
	setIsAccountDetailsOpen: (visible: boolean) => void;
	isAccountVisible: boolean;
	manageAccountUrl: string;
	className: string;
	setAppLoading?: (isLoading: boolean) => void;
	unavailableLanguages?:  Record<string, Language>;
	hasTranslationEnabled?:  boolean;
	failedToLoadLanguage?: (notification: NotificationViewModel, language: Language) => void;
	onError: (errorInfo: ErrorInfo, customData?: any) => void;
	hideI18n?: boolean | null;
	hideAccount?: boolean | null;
	transparentBackground?: boolean;
	supportsBackdrop: boolean;
	hasBackdrop?: boolean;
}


@observer
export class WebGivingMainHeader extends React.Component<IHeaderProps> {
	render() {
		const {
			person,
			setIsAccountDetailsOpen,
			isAccountVisible,
			merchant,
			brandingPackage,
			manageAccountUrl,
			className,
			onError,
			setAppLoading,
			unavailableLanguages,
			failedToLoadLanguage,
			hasTranslationEnabled,
			hideI18n = false,
			hideAccount = false,
			transparentBackground = false,
			supportsBackdrop,
			hasBackdrop = false
		} = this.props;
		const { PaymentLabel: paymentLabel } = merchant;
		return (
			<MainHeader
				className={className}
				transparentBackground={transparentBackground}
				onError={onError}
				welcomeMessage={person && <Text params={{person: person.Nickname}}>{`Hi, {{person}}`}</Text>}
				tradingName={merchant.TradingName}
				logoUrl={merchant.LogoUrl}
				merchantWebsiteUrl={merchant.WebsiteUrl}
				brandingPackage={brandingPackage}
				hasTranslationEnabled={hasTranslationEnabled}
				languageAndAccountHidden={Boolean(hideI18n && hideAccount)}
				supportsBackdrop={supportsBackdrop}
				hasBackdrop={hasBackdrop}
			>
				<ShouldTranslate>
					{(translate: boolean) =>
						translate && !hideI18n && (
							<React.Suspense fallback={ <div className={styles.container}> <Skeleton /> </div> }>
								<ErrorBoundary onError={this.props.onError}>
									<LanguageSelector
										tradingName={merchant.TradingName}
										paymentLabel={paymentLabel.VerbAppliedSentenceCase}
										setAppLoading={setAppLoading}
										unavailableLanguages={unavailableLanguages}
										failedToLoadLanguage={failedToLoadLanguage}
									/>
								</ErrorBoundary>
							</React.Suspense>
						)
					}
				</ShouldTranslate>
				<ErrorBoundary onError={this.handleErrorInAccountMenu}>
					{!hideAccount ? (
						<Account
							setAccountVisible={setIsAccountDetailsOpen}
							isAccountVisible={isAccountVisible}
							person={person}
							paymentLabel={paymentLabel}
							manageAccountUrl={manageAccountUrl}
						/>
					) : (
						<div className={styles.container} />
					)}
				</ErrorBoundary>
			</MainHeader>
		);
	}

	private handleErrorInAccountMenu = (errorInfo: ErrorInfo, customData?: any) => {
		this.props.setIsAccountDetailsOpen(false);
		this.props.onError(errorInfo, customData);
	}
}
